/**
 * Sticky add-to-cart: visível quando o botão principal sai do ecrã por baixo (scroll para baixo).
 * Não aparece no load se o ATC ainda estiver abaixo da dobra.
 */
(function () {
  function getObserveTarget(sectionId) {
    return (
      document.getElementById('ProductSubmitButton-' + sectionId) ||
      document.getElementById('ProductATCObserver-' + sectionId)
    );
  }

  function updateStickyVisibility(sticky, entry) {
    if (entry.isIntersecting) {
      sticky.hidden = true;
      return;
    }
    const r = entry.boundingClientRect;
    const vh = window.innerHeight;
    if (r.top > vh) {
      sticky.hidden = true;
    } else {
      sticky.hidden = false;
    }
  }

  function initStickyAtc(productInfo) {
    const sectionId = productInfo.dataset.section;
    if (!sectionId) return;

    const sticky = document.getElementById('ProductStickyATC-' + sectionId);
    if (!sticky) return;

    const stickyBtn = sticky.querySelector('[data-sticky-submit]');
    let io = null;
    let observed = null;

    function syncFromMain() {
      const priceEl = document.getElementById('price-' + sectionId);
      const stickyPrice = document.getElementById('StickyPrice-' + sectionId);
      const mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);

      if (priceEl && stickyPrice && !priceEl.classList.contains('hidden')) {
        stickyPrice.innerHTML = priceEl.innerHTML;
      } else if (stickyPrice) {
        stickyPrice.innerHTML = '';
      }

      if (mainBtn && stickyBtn) {
        stickyBtn.disabled = mainBtn.disabled;
        const span = mainBtn.querySelector('span');
        const stickySpan = stickyBtn.querySelector('span');
        if (span && stickySpan) stickySpan.innerHTML = span.innerHTML;
      }
    }

    function connectObserver() {
      const target = getObserveTarget(sectionId);
      if (!target) return;

      if (io && observed === target) {
        syncFromMain();
        return;
      }

      if (io) {
        io.disconnect();
        io = null;
      }
      observed = target;

      io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => updateStickyVisibility(sticky, e));
        },
        { threshold: 0, rootMargin: '0px 0px 12px 0px' }
      );
      io.observe(target);
      syncFromMain();
      requestAnimationFrame(() => {
        const rect = target.getBoundingClientRect();
        const fake = {
          isIntersecting: rect.top < window.innerHeight && rect.bottom > 0,
          boundingClientRect: rect,
        };
        updateStickyVisibility(sticky, fake);
      });
    }

    connectObserver();

    stickyBtn.addEventListener('click', () => {
      document.getElementById('ProductSubmitButton-' + sectionId)?.click();
    });

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (String(event.data?.sectionId) !== String(sectionId)) return;
        requestAnimationFrame(() => {
          syncFromMain();
          connectObserver();
        });
      });
    }

    syncFromMain();
    document.addEventListener('DOMContentLoaded', syncFromMain);
    document.addEventListener('shopify:section:load', (e) => {
      if (e.target?.contains?.(productInfo)) {
        requestAnimationFrame(connectObserver);
      }
    });
  }

  function boot() {
    document.querySelectorAll('product-info[id^="MainProduct"]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
